export default __webpack_public_path__ + "static/char-v-56-823ca233e625e6422106d923d0c61047.png";